import React from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import styles from './Chart.module.css';

const COLORS = ['#6366F1', '#F59E0B', '#10B981', '#EF4444', '#0EA5E9'];

// type: 'area' | 'bar' | 'pie'
export default function Chart({ type = 'area', data, dataKey = 'value', nameKey = 'name', height = 260 }) {
  if (!data || data.length === 0) {
    return <div className={styles.empty}>لا توجد بيانات كافية لعرض الرسم البياني</div>;
  }

  return (
    <div className={styles.chartBox} style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        {type === 'area' ? (
          <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="colorPrimary" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#6366F1" stopOpacity={0.35} />
                <stop offset="95%" stopColor="#6366F1" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis dataKey={nameKey} stroke="var(--text-light)" fontSize={12} />
            <YAxis stroke="var(--text-light)" fontSize={12} />
            <Tooltip contentStyle={{ borderRadius: 10, border: '1px solid var(--border)', fontFamily: 'Tajawal' }} />
            <Area type="monotone" dataKey={dataKey} stroke="#6366F1" strokeWidth={2.5} fill="url(#colorPrimary)" />
          </AreaChart>
        ) : type === 'bar' ? (
          <BarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis dataKey={nameKey} stroke="var(--text-light)" fontSize={12} />
            <YAxis stroke="var(--text-light)" fontSize={12} />
            <Tooltip contentStyle={{ borderRadius: 10, border: '1px solid var(--border)', fontFamily: 'Tajawal' }} />
            <Bar dataKey={dataKey} fill="#6366F1" radius={[8, 8, 0, 0]} />
          </BarChart>
        ) : (
          <PieChart>
            <Pie
              data={data}
              dataKey={dataKey}
              nameKey={nameKey}
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={85}
              paddingAngle={3}
            >
              {data.map((_, i) => (
                <Cell key={i} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip contentStyle={{ borderRadius: 10, border: '1px solid var(--border)', fontFamily: 'Tajawal' }} />
          </PieChart>
        )}
      </ResponsiveContainer>
    </div>
  );
}
